import { twMerge } from '@/styles/tailwindMergeConfig'
import { Responsible } from './Responsible'

export function TabsRight() {

  return (
    <div
      className={twMerge(
        'lg:w-[420px]',
        'flex flex-1 flex-col gap-2 lg:flex-none'
      )}
    >
       <Responsible />
    </div>
  )
}
